import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {ServerProvider} from '../../providers/server/server';
import {AuthenticationServiceProvider} from '../../providers/authentication-service/authentication-service';
import { AlertController } from 'ionic-angular';
import {AccountPage} from '../account/account';
import { LoadingController } from 'ionic-angular';

@Component({
    selector: 'page-login',
    templateUrl: 'login.html',
})
export class LoginPage {
    auth = {
        username: "",
        password: ""
    }

    constructor(public navCtrl: NavController,  public navParams: NavParams,
                public server : ServerProvider, public alertCtrl: AlertController,
                public auth_service: AuthenticationServiceProvider, public loadingCtrl: LoadingController) {
    }

    login(auth){
        let loader = this.loadingCtrl.create({
            content: "Bitte warten",
            duration: 5000
        });
        loader.present()
        this.server.auth(this.auth.username, this.auth.password).subscribe(
            data => {
                console.log("Login successfull");
                let user_obj = data.json()
                this.auth_service.SetCredentials(this.auth.username, this.auth.password, user_obj["id"]);

                this.navCtrl.setRoot(AccountPage);
                loader.dismiss()
            },
            err => {
                console.log("Login failed!");
                this.showError();
            }
        )
    }

    showError() {
        let alert = this.alertCtrl.create({
          title: 'Anmeldung fehlgeschlagen!',
          subTitle: 'Bitte überprüfen Sie Ihren Benutzernamen / Passwort.',
          buttons: ['OK']
        });
        alert.present();
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad LoginPage');
    }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts